import { render, staticRenderFns } from "./health-details.vue?vue&type=template&id=6d419dc2&"
import script from "./health-details.vue?vue&type=script&lang=js&"
export * from "./health-details.vue?vue&type=script&lang=js&"
import style0 from "./health-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports